const productOfferingsReducer = ( state = [], action ) => {
    let entityIndex;

    switch ( action.type ) {
        /** Payload
         * {
         *     addressId: Number,
         *     productOfferingId: Number,
         *     offered: Boolean
         * }
         */
        case 'updateProductOffering':
            entityIndex = state.findIndex( entity => entity.address.id === action.payload.addressId );
            if ( entityIndex !== -1 ) {
                const productOfferingIndex = state[entityIndex].productOfferings.findIndex( productOffering => productOffering.id ===
                    action.payload.productOfferingId );
                if ( productOfferingIndex !== -1 ) {
                    state[entityIndex].productOfferings[productOfferingIndex].offered = action.payload.offered;
                }
            }
            return state;

        /** Payload
         * {
         *     addressId: Number,
         *     displayOnMap: Boolean
         * }
         */
        case 'updateDisplayOnMap':
            entityIndex = state.findIndex( entity => entity.address.id === action.payload.addressId );
            if ( entityIndex !== -1 ) {
                state[entityIndex].displayOnMap = action.payload.displayOnMap;
            }
            return state;

        case 'toggleAllLocations':
            state.forEach( entity => entity.displayOnMap = action.payload.displayOnMap );
            return state;

        default:
            throw Error( `Unknown action "${action.type}" specified for productOfferingsReducer` );
    }
}

export default productOfferingsReducer;
